module.exports = __webpack_public_path__ + "static/img/lengdong.32ff80cc.svg";